import React, { useState, useEffect } from 'react';
import PageTitle from '../../module/pageTitle';
import LabelInput from '../../Component/labelInput';
import DropDown from '../../Component/dropdown';
import { InputField, Submitbtn } from '../../Component';
import ToggleButton from '../../Component/toggleButton';
import ImagePickerAndViewer from '../../Component/imagePickerAndViewer';
import AddMoreBtn from '../../Component/addMoreBtn';
import { getCompanyList, getDepartmentList, getSubDepartmentList, uploadFile, uploadPolicyFile, addPolicy } from './superAdminSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { showSnackbar, hideSnackbar } from '../../store/slices/snackbarSlice';

const AddPolicy = () => {
    const radioValue = [
        { _id: 1, name: "Common", value: 1 },
        { _id: 2, name: "Department", value: 2 },
    ];
    const dispatch = useDispatch<AppDispatch>();
    const initialVal = {
        policyTitle: "",
        PolicyPdfFile: "",
    };
    const [policyType, setPolicyType] = useState<any>();
    const [companyList, setCompanyList] = useState<any>([]);
    const [companyName, setCompanyName] = useState<any>();
    const [departmentList, setDepartmentList] = useState<any>([]);
    const [departmentName, setDepartmentName] = useState<any>();
    const [subDepartmentList, setSubDepartmentList] = useState<any>([]);
    const [subDepartmentName, setSubDepartmentName] = useState<any>();
    const [policyDetails, setPolicyDetails] = useState<any>([initialVal]);

    useEffect(() => {
        setPolicyType(1);
        dispatch(getCompanyList({
            callback: (res: any) => {
                setCompanyList(res?.data);
            },
            errorCallback: () => { }
        }));
        dispatch(getDepartmentList({
            callback: (res: any) => {
                setDepartmentList(res?.data);
            },
            errorCallback: () => { }
        }));
    }, []);

    const onChangeContent = (val: any, key: string) => {
        if (key === "policyType") setPolicyType(val);
        else if (key === 'company') setCompanyName(val);
        else if (key === 'department') {
            setDepartmentName(val);
            dispatch(getSubDepartmentList({
                id: val?._id,
                callback: (res: any) => {
                    setSubDepartmentList(res?.data);
                },
                errorCallback: () => { }
            }));
        }
        else if (key === 'subDepartment') setSubDepartmentName(val);
    }

    const onChangePolicyContent = (val: any, key: string, index: number) => {
        setPolicyDetails((prev: any) =>
            prev.map((item: any, i: any) => i === index ? { ...item, policyTitle: val } : item)
        );
    };

    const handlePDFChange = (e: any, index: number) => {
        e.preventDefault();
        if (!e.target.files?.[0]) return;
        const file = e.target.files[0];
        const reader = new FileReader();
        console.log("file", file);
        reader.onloadend = () => {
            dispatch(uploadPolicyFile({
                params: file,
                callback: (res: any) => {
                    if (res) {
                        setPolicyDetails((prev: any) =>
                            prev.map((item: any, i: any) => i === index ?
                                { ...item, PolicyPdfFile: res?.data?.filePath } : item
                            )
                        );
                    }
                },
                errorCallback: () => { },
            }));
        };

        reader.readAsDataURL(file);
    };
    const onPressAdd = () => {
        setPolicyDetails([...policyDetails, initialVal]);
    };
    const handleClose = (index: any) => {
        const newArray = [...policyDetails];
        if (index > -1) {
            newArray.splice(index, 1);
        }
        setPolicyDetails(newArray);
    };
    const handelSubmit = (e: any) => {
        e.preventDefault();
        const payload: any = {
            policyType: policyType,
            companyId: companyName?._id,
            policyDetails: policyDetails
        };
        if (departmentName) {
            payload["departmentId"] = departmentName?._id
        }
        if (subDepartmentName) {
            payload["subDepartmentId"] = subDepartmentName?._id
        }
        dispatch(addPolicy({
            params: payload,
            callback: (res: any) => {
                console.log("res", res);
                if (res?.status === "success") {
                    dispatch(showSnackbar({ message: res?.msg, type: res?.status }))
                    setTimeout(() => {
                        dispatch(hideSnackbar());
                    }, 5000);
                    setPolicyType('');
                    setCompanyName('');
                    setDepartmentName('');
                    setSubDepartmentName('');
                    setPolicyDetails(initialVal);
                    setCompanyList([]);
                    setDepartmentList([]);
                    setSubDepartmentList([]);
                };
            },
            errorCallback: () => { }
        }));
    };

    const renderForm = () => {
        return (
            <>
                <div className="col-md-4 mb-3">
                    <LabelInput labelName={"Company"} />
                    <DropDown
                        labelName={"Select Company"}
                        setInputText={(value: any) => onChangeContent(value, "company")}
                        options={companyList}
                        value={companyName}
                    />
                </div>
                {policyType !== 1 && (
                    <>
                        <div className="col-md-4 mb-3">
                            <LabelInput labelName={"Department"} />
                            <DropDown
                                labelName={"Select Department"}
                                setInputText={(value: any) => onChangeContent(value, "department")}
                                options={departmentList}
                                value={departmentName}
                            />
                        </div>
                        <div className="col-md-4 mb-3">
                            <LabelInput labelName={"Sub Department"} />
                            <DropDown
                                labelName={"Select Sub Department"}
                                setInputText={(value: any) => onChangeContent(value, "subDepartment")}
                                options={subDepartmentList}
                                value={subDepartmentName}
                            />
                        </div>
                    </>
                )}
                <LabelInput labelName={"Policy Details"} />
                <div className='col-md-6'>
                    {policyDetails?.map((item: any, index: number) => {
                        const { policyTitle, PolicyPdfFile } = item;
                        return (
                            <div className="col-md-12 mb-3 d-flex" key={index}>
                                <div className='bxshadow p-2 borderRadius mb-1 w-100'>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <LabelInput labelName={"Policy Title"} />
                                            <InputField
                                                key={"ex2"}
                                                placeholder={"Enter Policy Title"}
                                                value={policyTitle}
                                                setInputText={(value: any) => (onChangePolicyContent(value, "policyTitle", index))}
                                            // maxLength={100}
                                            // minLength={100} 
                                            />
                                        </div>
                                        <div className='col-md-5'>
                                            <LabelInput labelName={"Upload Policy PDF"} />
                                            <ImagePickerAndViewer
                                                value={PolicyPdfFile}
                                                handleChange={(value: any) => (handlePDFChange(value, index))}
                                                htmlFor={"pdf-upload-1"}
                                                doctype={"pdf"} />
                                        </div>
                                    </div>
                                </div>
                                {policyDetails?.length === 1 ? '' :
                                    <DeleteForeverIcon className='text-danger cursor' onClick={() => handleClose(index)} />
                                }
                            </div>
                        )
                    })}
                    <div className='col-md-4 p-0 ms-auto text-end'>
                        <AddMoreBtn handleClick={onPressAdd} />
                    </div>
                </div>
            </>
        )
    };

    return (
        <div className='panel-content'>
            <div className='mb-4'>
                <PageTitle name={"Add Policy"}
                    breadCrumb={""}
                    isEditMode={""}
                    cancelEdit={() => ('')} />
            </div>
            <div className='formDiv'>
                <div className='bxshadow p-2 borderRadius mb-4'>
                    <form onSubmit={handelSubmit}>
                        <div className="row">
                            <div className="col-md-12 mb-3">
                                <LabelInput labelName={"Policy Type"} />
                                <ToggleButton
                                    labelName={''}
                                    type={'radio'}
                                    name={"PolicyType"}
                                    options={radioValue}
                                    value={policyType}
                                    onChange={(value: any) => (onChangeContent(value, "policyType"))}
                                />
                            </div>
                            {renderForm()}
                        </div>
                        <div className='col-md-2 mx-auto my-4'>
                            <Submitbtn name={"Update"} disabled={false} />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AddPolicy;